<template>
    <div class="modal fade" id="modal_change_status_payement" tabindex="-1" data-bs-backdrop='static'
        aria-hidden="true">

        <div class="modal-dialog modal-lg">
            <div v-if="transaction" class="modal-content position-relative">
                <loader-gif v-if="isRequestPayment" />
                <div class="modal-header">

                    <h5 class="modal-title" id="varyingModalLabel">
                        Action de correction comptable
                    </h5>
                    <button @click="closeModal('modal_change_status_payement', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPayment">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="info-box">
                                <b class="bold">État actuel : </b>
                                <element-status-payment :status="transaction?.status" />

                            </div>
                            <div class="info-grid">
                                <div>
                                    <b class="bold">Montant : </b>
                                    <span>{{ transaction?.amount_paid }} {{ i18n.t('symbole.currency.mad') }}</span>
                                </div>
                                <div v-if="transaction?.dueDate">
                                    <b class="bold"> {{ i18n.t('tables.payment.accessBlockDate') }} : </b>
                                    
                                    <span> {{ formatDate(transaction?.dueDate) }} </span>
                                </div>
                            </div>
                        </div>
                        <hr>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <!-- CURRENT STATUS -->
                            <div class="info-box">
                                <b class="bold">État choisir : </b>
                                <element-status-payment :status="requestPayment?.status" />
                            </div>

                            <!-- WARNING -->
                            <div v-if="requestPayment.status == 'paid'" class="warning-box">
                                <h3> <b>⚠️ Impact de cette action</b> </h3>
                                <ul>
                                    <li>Le statut passera à <b>Payé</b></li>
                                    <li>Le montant sera ajouté à la <b>caisse</b></li>
                                    <li>Les rapports financiers seront mis à jour</li>
                                </ul>
                            </div>

                            <div v-else-if="requestPayment.status == 'scheduled'">
                                <!-- WARNING -->
                                <div class="info-box">
                                    <p>
                                        Vous êtes sur le point de modifier un paiement déjà validé.
                                    </p>
                                </div>
                                <!-- FINANCIAL IMPACT -->
                                <div class="warning-box">
                                    <h3> <b>ℹ️ Impact de la modification</b> </h3>
                                    <ul>
                                        <li>Le statut sera remis à <b>En attente</b></li>
                                        <li>Le montant sera retiré de la caisse</li>
                                        <li>Les rapports financiers seront mis à jour</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <form class="forms-sample" @submit.prevent="submitForm">

                        <div class="row">
                            
                            <div class="col-md-12">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.status')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPayment.status"
                                    :placeholder="i18n.t('tables.payment.status')" :arrayOptions="payementStatusList"
                                    refs="status" :v="v$.status" />
                            </div>
                            <div class="col-md-12">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPayment.paymentDate"
                                        :label="i18n.t('tables.payment.paymentDate')" :v="v$.paymentDate"
                                        :disabled="false" />
                                </div>
                            </div>


                            <div class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.paymentMethod')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPayment.paymentMethod"
                                    :placeholder="i18n.t('tables.payment.paymentMethod')"
                                    :arrayOptions="payment_methodsList" refs="paymentMethod" :v="v$.paymentMethod" />
                            </div>
                            <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <SingleSelect :TextLabel="i18n.t('tables.payment.bankName')" :trackby="`id`"
                                    :label="`name`" :valueProp="`id`" v-model="requestPayment.bankName"
                                    :placeholder="i18n.t('tables.payment.bankName')" :arrayOptions="bank_namesList"
                                    refs="bankName" :v="v$.bankName" />
                            </div>

                            <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPayment.chequeName"
                                        :label="i18n.t('tables.payment.chequeName')" :v="v$.chequeName"
                                        :disabled="false" />
                                </div>
                            </div>
                            <div v-if="requestPayment.paymentMethod === 'Chèque bancaire'" class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <inputText v-model="requestPayment.chequeNum"
                                        :label="i18n.t('tables.payment.chequeNum')" :v="v$.chequeNum"
                                        :disabled="false" />
                                </div>
                            </div>

                            <div v-if="requestPayment.paymentMethod === 'Chèque bancaire' || requestPayment.status == 'scheduled'"
                                class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <date-field v-model="requestPayment.dueDate"
                                        :label="requestPayment.status == 'scheduled' ? i18n.t('tables.payment.accessBlockDate') : i18n.t('tables.payment.dueDate')"
                                        :v="v$.dueDate" :disabled="false"
                                        :fixedDays="1" :isFixedDays="false" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group mr-b-0em">
                                    <price-input v-model="requestPayment.amount_paid"
                                        :label="i18n.t('tables.payment.amount_paid')" :v="v$.amount_paid"
                                        :disabled="false" />
                                </div>
                            </div>


                            <div class="col-12 text-right">
                                <button type="submit" class="btn btn-primary mr-2">
                                    Confirmer le paiement
                                </button>
                                <button type="button" @click="emptyState()" class="btn btn-cancel">

                                    {{ i18n.t('button.clean') }}
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, PropType, watch } from "vue";

/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";
/*plugins*/
import { useRoute } from "vue-router";



import { useVuelidate } from "@vuelidate/core";
import { required, helpers, requiredIf, numeric } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import dayjs from 'dayjs';
import router from "@/router/index";

/*composables & states */
import { usePayment } from "@/composables/payment/usePayment";
import { useModal } from '@/composables/modal/useModal';
import { StatusPayementRequest, Payment } from "@/interfaces/payment";
import { usePermission } from "@/composables/auth/usePermission";
import { useGlobal } from "@/composables/global/useGlobal";

import { clubUUID, payementStatus, bank_names, payment_methods } from "@/shared/state";
export default defineComponent({
    components: { inputText, SingleSelect },
    name: "change-status-payment",
    props: {
         subscriptionDetails: {
            default: null,
            type: Object,
        },
        transaction: {
            type: Object as PropType<Payment>,
            default: null,
        },
        memberUUID: {
            default: null,
            type: String
        }
    },
    setup(props) {
         const { transaction , subscriptionDetails  } = toRefs(props);
        const { formatDate } = useGlobal();
        const requestPayment = ref<StatusPayementRequest>({
            id: transaction?.value?.id ?? null,
            status: "paid",
            memberUUID: props?.memberUUID ?? null,
            paymentMethod: null,
            bankName: null,
            chequeName: null,
            chequeNum: null,
            dueDate: null,
            amount_paid: null,
            paymentDate: dayjs(new Date()).format('YYYY-MM-DD'),

            reference_id: transaction?.value?.reference_id ?? null,
            reference_type: "subscriptions"
        });

        const { changeStatus, isRequestPayment, errorPayment } = usePayment();
        const { closeModal } = useModal();
        const { hasPermission } = usePermission();
        const bank_namesList = computed(() => bank_names.value);
        const payment_methodsList = computed(() => payment_methods.value);
        const payementStatusList = computed(() => payementStatus.value);
        // Validation   
        const rules = {
            id: {},
            status: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            memberUUID: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            paymentMethod: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            bankName: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            chequeName: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            chequeNum: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire')
            },
            dueDate: {
                requiredIf: requiredIf(() => requestPayment.value.paymentMethod === 'Chèque bancaire' || requestPayment.value.status !== 'paid')
            },
            paymentDate: {
                required: helpers.withMessage(i18n.t("validation.required"), required)
            },
            // amount_paid: {
            //     required: helpers.withMessage(i18n.t("validation.required"), required)
            // },
            amount_paid: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
                numeric,
                paidAmountValid: helpers.withMessage(
                    i18n.t("validation.amountExceededError"),
                    (value) => {
                        const numberValue = Number(value);
                        return numberValue !== null && numberValue <= totalRemainingAmount.value;
                    }
                )
            },
        };
        const v$ = useVuelidate(rules, requestPayment, { $scope: 'statusPayement' });

        const totalRemainingAmount = computed(
            () => {
                const total_amount = subscriptionDetails?.value?.remaining_amount ?? 0;
                return parseFloat((total_amount).toFixed(2));
            }
        )

        watch(
            () => transaction.value,
            (newValue) => {

                initState(transaction.value)

            });


        /**
         * Add or edit member
         */
        const submitForm = async () => {
            requestPayment.value.memberUUID = props?.memberUUID ?? null,
                v$.value.$touch();
            if (transaction.value.status == requestPayment.value.status) {
                Swal.fire({
                    title: "Vous ne pouvez pas modifier le statut vers le même état.",
                    icon: "error",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.ok"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false,   // ✅ disable closing by clicking outside
                    allowEscapeKey: false       // (optional) disable closing with ESC
                })
                return false
            }


            if (!v$.value.$invalid) {
                Swal.fire({
                    title: i18n.t("message.confirmation.edit.title"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: i18n.t("button.edit"),
                    cancelButtonText: i18n.t("button.cancel"),
                    allowOutsideClick: false,   // ✅ disable closing by clicking outside
                    allowEscapeKey: false       // (optional) disable closing with ESC
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await changeStatus(requestPayment.value)
                            .then((res) => {
                                if (res?.data) {
                                    setTimeout(() => {
                                        location.reload();
                                    }, 500);
                                }
                            })
                            .catch((e) => {
                                console.log(e);
                            });

                    }
                });
            }
        }

        const emptyState = () => {

            requestPayment.value.id = null
            requestPayment.value.status = null
            requestPayment.value.memberUUID = null
            requestPayment.value.paymentMethod = null
            requestPayment.value.bankName = null
            requestPayment.value.chequeName = null
            requestPayment.value.chequeNum = null
            requestPayment.value.dueDate = null
            requestPayment.value.amount_paid = null
            requestPayment.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            requestPayment.value.reference_id = null
            closeModal('modal_change_status_payement', 'add')
            v$.value.$reset();

        };

        const initState = (transaction) => {
            requestPayment.value.id = transaction?.id ?? null
            requestPayment.value.status = transaction?.status ?? null
            requestPayment.value.dueDate = transaction?.dueDate ?? null
            requestPayment.value.amount_paid = transaction?.amount_paid ?? null
            requestPayment.value.paymentMethod = transaction?.paymentMethod ?? null
            requestPayment.value.bankName = transaction?.bankName ?? null
            requestPayment.value.chequeName = transaction?.chequeName ?? null
            requestPayment.value.chequeNum = transaction?.chequeNum ?? null
            requestPayment.value.paymentDate = dayjs(new Date()).format('YYYY-MM-DD')
            requestPayment.value.memberUUID = props?.memberUUID ?? null
            requestPayment.value.reference_id = transaction?.reference_id ?? null
            v$.value.$reset();
        };
        watch(() => requestPayment.value.paymentMethod, (newValue) => {
            if (newValue !== 'Chèque bancaire') {
                requestPayment.value.bankName = null
                requestPayment.value.chequeName = null
                requestPayment.value.chequeNum = null
            }
        });

        return {
            bank_namesList,
            payment_methodsList,
            payementStatusList,
            requestPayment,
            submitForm,
            emptyState,
            v$,
            i18n,

            dayjs,
            isRequestPayment,
            closeModal,
            formatDate
        };
    },
});
</script>

<style>
.icon {
    font-size: 24px;
}

.subtitle {
    font-size: 12px;
    color: #666;
}

.modal-body {
    padding: 16px;
}

.info-box {
    margin-bottom: 12px;
}

.info-grid {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
}

.warning-box {
    background: #ffb230;
    border: 1px solid #ebebeb;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 16px;
}

.warning-box h3 {
    margin: 0 0 8px 0;
    font-size: 14px;
}

.checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
}



button {
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    cursor: pointer;
}

.btn-secondary {
    background: #e2e8f0;
}

.btn-danger {
    background: #e53e3e;
    color: white;
}

.btn-danger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.badge {
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
}

.current {
    background: #1680fa;
    color: #0d0d0e;
}

.scheduled {
    background: rgb(192, 2, 2);
    color: #ffffff;
}

.paid {
    background: rgb(2, 192, 2);
    color: #0d0d0e;
}
</style>